import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent {
  constructor(private dialogRef: MatDialogRef<PrivacyPolicyComponent>) {}

  accept() {
    this.dialogRef.close(true);
  }
}
